<template>
  <div id="activity" class="maincont child status-change-history">
      <div class="ef--inner2">
        <div class="filter">
          <div class="filter-condition account-list-filter-condition">
            <ul class="filter-condition-list">
              <li class="filter-condition-list-item">
                <label class="mr-1">表示期間</label>                
                <datepicker
                  :minimum-view="'day'"
                  format="yyyy年MM月dd日"
                  :language="ja"
                  input-class="input-date"
                  class="custom-date"
                  v-model="getStartDay"
                ></datepicker>
                <span class="tilde">~</span>
                <datepicker
                  :minimum-view="'day'"
                  format="yyyy年MM月dd日"
                  :language="ja"
                  :disabled-dates="this.dayInfo.disabled.end"
                  input-class="input-date"
                  class="custom-date"
                  v-model="getEndDay"
                ></datepicker>
              </li>              
              <li class="filter-condition-list-item-check">
                <label class="mr-1">表示設定</label>
                <div class="group-form-check">
                  <label>2値：</label>
                  <ul class="form-check-inline">
                    <li class="form-check form-check-inline" 
                      v-for="(item, index) in statusDivisonBinaryList"
                      v-bind:key="index">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :id="'display_setting_' + item.value"
                        :value="item.value"
                        v-model="statusDivsionIdList"
                      />
                      <label :for="'display_setting_' + item.value">{{ item.name }}</label>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="filter-condition-list-item-check">
                <div class="group-form-check">
                  <label>通信：</label>
                  <ul class="form-check-inline">
                    <li class="form-check form-check-inline" 
                      v-for="(item, index) in statusDivisonCommunicationList"
                      v-bind:key="index">
                      <input
                        type="checkbox"
                        class="form-check-input"
                        :id="'display_setting_' + item.value"
                        :value="item.value"
                        v-model="statusDivsionIdList"
                      />
                      <label :for="'display_setting_' + item.value">{{ item.name }}</label>
                    </li>
                  </ul>
                </div>
              </li>
              <li class="filter-condition-list-item filter-condition-button">
                <button
                  class="bt-csv"
                  @click="downloadCSV()"
                >
                  CSVダウンロード
                </button>
              </li>
              <li class="filter-condition-list-item">
                <button class="bt-cyan" @click="getHistories()">更新</button>
              </li>
              <li></li>
            </ul>
          </div>
        </div>
        <div class="scroll" style="height: 580px">
          <table id="maintenance-table" class="normal-table">
            <thead>
              <tr>
                <th>日時</th>
                <th>サイト名</th>
                <th>設備区分</th>
                <th>名称</th>
                <th>状態区分</th>
                <th>状態</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item) in historyList"
                v-bind:key="item.id"
                :class=" statusDivisonBinaryObject[item.stateClassification].class"
              >
                <td>{{ item.date }}</td>
                <td class="text-start">{{ item.siteName }}</td>
                <td>{{ item.equipmentClassification }}</td>
                <td class="text-start">{{ item.name }}</td>
                <td>{{ statusDivisonBinaryObject[item.stateClassification].name_jp }}</td>
                <td>{{ item.state }}</td>
              </tr>
              <tr v-if="historyList.length == 0">
                <td colspan="6">データがありません</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
</template>

<script>
import moment from "moment-timezone";
import Datepicker from "vuejs-datepicker";
import { ja } from "vuejs-datepicker/dist/locale";
import Utils from "../../utils/utils"

/* eslint-disable no-console */
/* eslint-disable no-unused-vars */
export default {
  name: "status-change-history",
  components: {
    Datepicker,
  },
  data: function() {
    return {
      moment: moment,
      ja: ja,
      name: "",
      historyList: [],
      dayInfo: {
        disabled: {
          start: { from: null, to: null },
          end: { from: null, to: null },
        },
        param: {
          start: null,
          end: null,
        },
      },
      statusDivisonBinaryList: [
        {
          value: 3,
          name: '故障(軽)'
        },
        {
          value: 2,
          name: '故障(重)'
        },
        {
          value: 1,
          name: '状態'
        },
      ],
      statusDivisonBinaryObject: {
        'normal': {
          name_jp : '状態',
          class: 'text-info'
        },
        'serious':{
          name_jp : '故障(重)',
          class: 'text-danger'
        },
        'minor': {
          name_jp : '故障(軽)',
          class: 'text-warning'
        },
        'comm_error': {
          name_jp : '通信異常',
          class: 'text-danger'
        },
        'missing_data': {
          name_jp : '欠測',
          class: 'text-danger'
        },
      },
      statusDivisonCommunicationList: [
        {
          value: 4,
          name: '通信異常'
        },  
        {
          value: 5,
          name: '欠測'
        },
      ],
      statusDivsionIdList: [1,2,3,4,5],
    };
  },
  methods: {
    // Get historyList from API
    getHistories: function() {
      const params = new URLSearchParams();
      params.append("startDate", this.dayInfo.param.start)
      params.append("endDate", this.dayInfo.param.end)
      params.append("statusId", this.statusDivsionIdList.join(','))

      const request = {
          params: params,
          withCredentials: true
      }

      this.$axios
        .get(`/srv/api/status_change_history`, request
        )
        .then((response) => {
          this.historyList = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    downloadCSV() {
      const data = this.historyList;
      const statusDivsion = this.statusDivisonBinaryObject
      const fileName = `状変履歴画面`;
      const header = ['日時', 'サイト名', '設備区分', '名称', '状態区分', '状態']
      if (data.length) {
        const rowData = JSON.parse(JSON.stringify(this.historyList)).map(function(item) {
          delete item.id
          item.stateClassification = statusDivsion[item.stateClassification].name_jp
          return Object.values(item);
        })
        Utils.exportData(rowData, fileName, header)
      }
    },
    getDateWithFormat(value) {
      return moment(value).format('YYYY-MM-DD')
    },
    setDateWithFormat(value) {
      if (value) {
        return moment(new Date(value).toISOString().split('T')[0]).format('YYYY-MM-DD')
      } else {
        return moment(new Date().toISOString().split('T')[0]).format('YYYY-MM-DD')
      }
    }
  },
  mounted: function() {
    this.dayInfo.param.start = this.setDateWithFormat();
    this.dayInfo.param.end = this.setDateWithFormat();

    this.getHistories();
  },
  computed: {
    getStartDay: {
      get: function() {
        return this.getDateWithFormat(this.dayInfo.param.start);
      },
      set: function(newValue) {
        this.dayInfo.param.start = this.setDateWithFormat(newValue);
      },
    },
    getEndDay: {
      get: function() {
        return this.getDateWithFormat(this.dayInfo.param.end);
      },
      set: function(newValue) {
        this.dayInfo.param.end = this.setDateWithFormat(newValue);
      },
    },    
  },
};
</script>
